'use client';

import type { CmsShellViewerMode } from '@/cms/chrome/shell-viewer-mode';
import {
  useCmsAccountLocalCopy,
  useCmsAccountSignOut,
} from '@/cms/components/chrome/cms-account-menu';
import { useCmsAccountSettingsDialog } from '@/cms/components/chrome/cms-account-settings-state';
import { CmsShellViewerState } from '@/cms/components/chrome/cms-shell-viewer-state';
import { LazyCmsAccountSettingsDialog } from '@/cms/components/chrome/lazy-cms-account-settings-dialog';
import type { CmsAccountSettingsPresentation } from '@/components/account-settings/cms-account-settings-dialog';

export function CmsAccountSettingsDialogHost({
  locale,
  presentation,
  viewerMode,
}: {
  locale: string;
  presentation: CmsAccountSettingsPresentation;
  viewerMode: CmsShellViewerMode;
}) {
  const settingsDialog = useCmsAccountSettingsDialog();

  return (
    <CmsShellViewerState mode={viewerMode}>
      {({ currentUser, isAuthenticated }) =>
        isAuthenticated && currentUser && settingsDialog.hasOpened ? (
          <AuthenticatedCmsAccountSettingsDialog
            locale={locale}
            presentation={presentation}
            settingsDialog={settingsDialog}
          />
        ) : null
      }
    </CmsShellViewerState>
  );
}

function AuthenticatedCmsAccountSettingsDialog({
  locale,
  presentation,
  settingsDialog,
}: {
  locale: string;
  presentation: CmsAccountSettingsPresentation;
  settingsDialog: ReturnType<typeof useCmsAccountSettingsDialog>;
}) {
  const copy = useCmsAccountLocalCopy();
  const { handleSignOut } = useCmsAccountSignOut(locale, copy);

  return (
    <LazyCmsAccountSettingsDialog
      activeSection={settingsDialog.activeSection}
      copy={copy}
      onActiveSectionChange={settingsDialog.onActiveSectionChange}
      onLogout={() => {
        void handleSignOut();
      }}
      onOpenChange={settingsDialog.onOpenChange}
      open={settingsDialog.open}
      presentation={presentation}
    />
  );
}
